import { render, staticRenderFns } from "./BasicInfoForm.vue?vue&type=template&id=3261add4&scoped=true&"
import script from "./BasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./BasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3261add4",
  null
  
)

export default component.exports